import { Directive, Output, EventEmitter, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[appDynamicTooltip]',
    standalone: false
})
export class DynamicTooltipDirective {

    el = inject(ElementRef);

    @Output()
    onToolTip = new EventEmitter();

    @HostListener('mouseover')
    mouseOver(): void {
        const isTruncated = this.isTextTruncated(this.el.nativeElement as HTMLElement);
        if (isTruncated) {
            this.onToolTip.emit({ element: this.el.nativeElement, truncated: isTruncated });
        }
    }

    isTextTruncated(element: HTMLElement): boolean {
        //In Tabellen wird ein Element zu weit unten erwischt. Wir suchen das Parent-Element, welches die Größen gesetzt hat
        let e = element.scrollWidth > 0 || element.scrollHeight > 0 || element.parentElement == null ? element : element.parentElement;
        return e.scrollWidth > e.clientWidth;
    }
}
